export default "__VITE_ASSET__DF1NnDeS__"